// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sapper_mainCotainerRoulete__gvOiz{
    display: flex;
    flex-direction: column;

    color:whitesmoke;
    
    min-height: 100vh;
    font-family: Popins,sans-serif;
    padding: 0 10px;
}
.Sapper_step__DBagP {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    margin-bottom: 10px;
    color: white;
    line-height: 1.5;
    text-align: center;
  }
  
  .Sapper_highlight__GcwZ7 {
    color: greenyellow;
    font-weight: bold;
  }
.Sapper_button__QbDZN{
    display: flex;
    justify-content: center;
}
.Sapper_nextKoef__\\+Urxr{
    background-color: green!important;
    animation: Sapper_fadeInKoef__9I1Re 0.5s ease; /* Анимация появления */

}
.Sapper_buttonsTools__mSXrl{
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap:10px;
    z-index: 2;
}
.Sapper_howToPlay__UJ2dF{
    background-color: #0f1721;
}
.Sapper_infoMaxWin__4qP7W{
    display: flex;
    justify-content: center;
    font-size: 17px;
    gap:10px;
    background: #00000061;
    padding: 10px;
    border-radius: 10px;
    color: gold;
}
.Sapper_infoMaxWin__4qP7W div{
    text-align: center;
}
.Sapper_shiny_button__pTRwB{
    position: relative;
    display: inline-block;
    font-size: 20px;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 1px;
    background: linear-gradient(45deg, #ff8c00, #ffa500);
    border: none;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0 3px 12px rgba(255, 140, 0, 0.7);
    transition: transform 0.3s ease;
    text-align: center;
}

.Sapper_shiny_button__pTRwB::before {
    content: "";
    position: absolute;
    top: 0;
    left: -150%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
    transform: skewX(-15deg);
    animation: Sapper_shiny-animation__En5B6 2.5s infinite;
}

@keyframes Sapper_shiny-animation__En5B6 {
    0% {
        left: -150%;
    }
    50% {
        left: 100%;
    }
    100% {
        left: 100%;
    }
}


.Sapper_containerMines__dvWVf{
    display: flex;
    justify-content: space-between;
    background: #7223ca8a;
    padding: 10px;
    border-radius: 10px;
}
.Sapper_infoMin__po2Pp{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size: 18px;
    letter-spacing: 1px;
    font-family: Popins,sans-serif;
}
.Sapper_buttonChoiceMine__YUGxa{
    text-align: center;
    font-size: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    color:white;
    width:39px;
    height:39px;
    border-radius: 10px;
    background-color: #293069;
    cursor: pointer;
}
.Sapper_containerBets__Q3-9D{
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin:1rem 2rem 0 2rem;
}
.Sapper_cellsContainer__FtYUg {
    display: grid;
    grid-template-columns: repeat(5, 60px); /* Сетка для ячеек */
    grid-gap: 5px;
    background: linear-gradient(135deg, #b8005980, #00a9c0ab); /* Градиентный фон для контейнера */
    padding: 15px; /* Внутренние отступы для контейнера с ячейками */
    border-radius: 15px; /* Закругление углов контейнера */
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3), 0 6px 6px rgba(0, 0, 0, 0.23); /* Тень для выделения */
    transition: transform 0.3s ease, box-shadow 0.3s ease; /* Плавный переход для эффекта наведения */
}
.Sapper_textQtyMine__uWWgc {
    font-size: 14px;
}
.Sapper_cellsContainer__FtYUg:hover {
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 10px 10px rgba(0, 0, 0, 0.2); /* Усиление тени при наведении */
}
.Sapper_cell__gySjS {
    width: 60px;
    height: 60px;
    cursor: pointer;
    background-color: #ffffff52;
    border: 2px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333;
    border-radius: 8px; /* Закругление углов ячеек */
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1); /* Внутренняя тень для ячеек */
    transition: background-color 0.3s ease, transform 0.3s ease; /* Плавный переход для ячеек */
}

.Sapper_cell__gySjS:hover {
    background-color: #0000004d; /* Изменение цвета при наведении */
    transform: scale(1.1); /* Легкое увеличение при наведении */
    border: 1px solid #ffffff42;
}

body{
    color: #0f1721;
}
@keyframes Sapper_ApperAnimate__PhGIk {
    0% {
        opacity: 0;

    }
    100% {
        opacity: 1;

    }
}
.Sapper_main__JWUG8{
    margin-top: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.Sapper_mainGame__XMdfq{

    z-index: 1000;     /* establish flex container */

    display: flex;
    flex-direction: row;            /* default value; can be omitted */
    flex-wrap: nowrap;              /* default value; can be omitted */

}
.Sapper_containerInfGame__ks0vt{
    display: flex;
    flex-direction: column;
    width: 30%;
    align-items: center;
    justify-content: center;
    order: 0;

}
.Sapper_textContainer__Qj4qu {
    font-size: 30px;
    color: whitesmoke;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
    /*margin-top: 20px; !* Регулируйте, чтобы создать желаемый отступ между текстом и таймером *!*/
}
.Sapper_containerNamingsGame__7RXtW{
    /*margin:10px;
    margin-left: 20px;
    margin-bottom: 10px;*/
    text-align: center;
    font-family: Poppins, sans-serif;
    margin: 20px;
}

.Sapper_containerBetInGame__puzDj{
    display: flex;
    flex-direction: row;
    order: 2;
    justify-content: space-between;
    align-items: center;
    flex-basis: calc(25% - 0.5rem);
    height: 60px;
    gap: 1.5rem;
    background: linear-gradient(315deg, var(--bg-color-start) 50%, var(--bg-color-end) 100%);
    border-radius: 1rem;
    padding: 1rem;
    animation: Sapper_ApperAnimate__PhGIk 0.8s ease-in-out;
    animation-fill-mode: forwards;
    margin-bottom: 1rem;

}
.Sapper_AllAmount__tCQ4-{
    font-size: 25px;
    color: #1be513;
    font-family: Poppins, sans-serif;
    margin-right: 1rem;
}

.Sapper_animateAmount__ah6Qo{
    animation: Sapper_expandAnimation__tCC2X 1.5s ease forwards;

}
@keyframes Sapper_expandAnimation__tCC2X {
    0% {
        opacity: 0;
        transform: scale(1); /* Начальный масштаб */

    }
    100% {
        opacity: 1;

        transform: scale(1.5); /* Конечный масштаб */

    }
}
.Sapper_headerBetName__N\\+VJ8{
    font-size: 20px;
    color: var(--font-color);
    font-family: Poppins, sans-serif;
    margin-left: 1rem;
}

.Sapper_wrapperContentGame__12YMx{
    display: flex;
    flex-direction: row;
    background-color: #242c54;
    border-radius: 10px;
    flex-flow: row-reverse;
    position:relative;
}
.Sapper_containerGame__xGbMC {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center; /* Центрируем контейнер с ячейками по горизонтали */
    flex-direction: column;
    align-items: center; /* Центрируем контейнер с ячейками по вертикали */
    padding: 20px; /* Добавляем отступы, чтобы контейнер был четко отделен от границ экрана */
    padding-top:50px;
    gap:20px;
}
.Sapper_containerKoefs__OeUFn{
    display: flex;
    justify-content: center;
    gap:10px;
    flex-wrap: wrap;
}
@keyframes Sapper_fadeIn__P2Kym {
    from {
        opacity: 0;
        transform: scale(0);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
@keyframes Sapper_fadeInKoef__9I1Re {
    from {
        
        transform: scale(0.5);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
.Sapper_blockHistoryButton__jpVHW {
    
    cursor: pointer;
    z-index: 2;
}
.Sapper_koefBlock__Lvish{
    border-radius: 10px;
    background-color: #6c8af999;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Poppins, sans-serif;
    flex-wrap: wrap;
}

.Sapper_koefBlock__Lvish.Sapper_achive__8R9eE{
    background: linear-gradient(45deg, #ff8c0091, #ffa500);
    animation: Sapper_fadeInKoef__9I1Re 0.5s ease; /* Анимация появления */

}
.Sapper_upI__d8q8K{
    position: absolute;
    top:-5%;
    left: 52%;
    transform: translate(-50%, -50%);
    color: #96e5b6;
    font-size: 32px;
    rotate: -45deg;
}
.Sapper_blockInf__vx9lh{

    display: flex;
    height: 100%;

    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap:0.5rem;
}
.Sapper_blockInf__vx9lh h2{
    color: whitesmoke;
    font-family: "Gilroy", sans-serif;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 1.6rem;
    text-align: center;
}
.Sapper_timerI__csuct{
    font-size: 23px;
    color:#96e5b5;
}
.Sapper_containerTimer__vN5Uu{
    display: flex;
    flex-direction: row;
    gap:1rem;
}
.Sapper_containerLast10__apVzA{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap:4px;
}

.Sapper_blockLast10__aprpV{
    width: 8px;
    height: 1rem;
    border-radius: 10px;

    background: linear-gradient(180deg, var(--bg-color-start) 0%, var(--bg-color-end) 100%);
}
.Sapper_blockLast10__aprpV.Sapper_x_3__B0puR{
    height: 1.5rem;
}
.Sapper_blockLast10__aprpV.Sapper_x_5__oX2Zj{
    height: 2rem;
}
.Sapper_containerInforamtionWheel__Z6jeY{
    position: relative;
    top:0;
    left: 0;
    display: block;
    width: 200px;
    height: 300px;

}



.Sapper_wrapperSvg__qu2gs,.Sapper_containerInforamtionWheel__Z6jeY{
    position: absolute; /* Абсолютное позиционирование */
    top: 50%; /* Положение по вертикали в середине блока */
    left: 50%; /* Положение по горизонтали в середине блока */
    transform: translate(-50%, -50%); /* Центрируем по вертикали и горизонтали */
}

.Sapper_wrapper__8sCnG{
    position: relative;
    margin: 0 auto;
}
.Sapper_containerTable__b3OmQ{

    display: flex;
    order: 1;
    flex-direction: column;
    max-width: 500px;
    justify-content: center;

    gap: 1rem;
    border-right: 1px solid #ffffff30; /* Добавляем красную линию справа */
    padding: 3rem 3rem;
}
.Sapper_result__Araf6{
    width: 60px;
    height: 60px;
    font-size: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(4, 197, 4);
    animation: Sapper_fadeIn__P2Kym 0.5s ease; /* Анимация появления */
    border: 2px solid #ffffff42;
    border-radius: 8px;
}
.Sapper_no_bets__9y8XF{
    display: flex;
    margin-right: 30px;

    justify-content: center;
    align-items: center;
    order: 3;
    font-size: 30px;
    color: white;
    font-family: Gilroy, sans-serif;
    font-weight: 700;
}
.Sapper_containerBetsInf__STTQB{
    margin-top: 30px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    order: 2;
    flex-direction: column;
    gap: 1em;
}
.Sapper_containerBet__RjNO3{

    display: flex;
    flex-direction: row;
    order: 2;
    width: 100%;
    justify-content: left;
    align-items: center;
    height: 50px;
    gap: 1.5rem;
    background-color: #242c54;
    border-radius: 3rem;
    padding: 1rem;
    animation: Sapper_ApperAnimate__PhGIk 0.5s ease-in-out;
    animation-fill-mode: forwards;

}
.Sapper_betsAmountInf__d6KJx{
    color: greenyellow;
    font-size: 20px;
    font-family: Gilroy, sans-serif;
    font-weight: 600;
}
.Sapper_btnCancel__bEhfM{
    background-color: red;
}
.Sapper_choice_container__fXzOv{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.Sapper_imgContainer__MTtai{
    margin-top: 1rem;

    display: flex;


    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}
.Sapper_imgContainer__MTtai img{
    width: 100%;
    height: auto; /* Сохраняем пропорции изображения */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
    pointer-events: none; /* Отключение взаимодействия с изображением */

}
.Sapper_img__yPkas
.Sapper_selected__XtAoT {
    opacity: 1;
}


.Sapper_bet_container__Dy3Uo{

    display: flex;
    justify-content: center;
    flex-direction: column;

    /*width: 300px;*/
}
.Sapper_select-color__color_x2__Ulolt {
    --font-color: #94B2FF;
    --bg-color-start: rgba(90, 96, 228, .224);
    --bg-color-end: rgba(88, 103, 236, .64);
    --border-color: rgba(139, 157, 254, .18);

}
.Sapper_select-color__color_x50__tGjA2 {
    --font-color: #A4FDC7;
    --bg-color-start: rgba(43, 172, 71, .224);
    --bg-color-end: rgba(74, 202, 110, .64);
    --border-color: rgba(139, 254, 185, .18);

}
.Sapper_select-color__color_x3__b9y9u {
    --font-color: #ef294e;
    --bg-color-start: rgb(208 74 74 / 12%);
    --bg-color-end: rgb(255 11 11 / 34%);
    --border-color: rgba(184, 151, 255, .18);
}
.Sapper_select-color__color_x5__mZpYC {
    --font-color: #FFEDC8;
    --bg-color-start: rgba(216, 164, 87, .224);
    --bg-color-end: rgba(218, 197, 87, .64);
    --border-color: rgba(254, 208, 139, .18);
}
.Sapper_opac__HkBYh{
    opacity: 0.1;
}
@keyframes Sapper_pulse__fiUzM {
    0% {
        font-size: 20px;
    }
    50% {
        font-size: 30px;
    }
    100% {
        font-size: 20px;
    }
}
.Sapper_text_block__pVOB7{
    z-index: 1000;
    width: 100%;
    display: flex;

    margin-top: 30px;
    justify-content: center;
    font-family: "Gilroy" , sans-serif;
    font-weight: 600;
    color: #053fc7;
    animation: Sapper_pulse__fiUzM 2s infinite alternate;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}
.Sapper_blockButtonCancel__uEuRF{
    font-size: 28px;
    color: red;
    cursor: pointer;
    margin-left: auto; /* Это свойство поместит блок .blockButtonCancel в конец контейнера */


}
.Sapper_btnCancel__bEhfM {
    width: 50px;
    height: 50px;
    box-shadow: 0px 10 10px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    background: red;
    cursor: pointer;

    position: absolute;
    display: block;
    z-index: 200;
    text-indent: -9999px;
}

.Sapper_btnCancel__bEhfM:before,
.Sapper_btnCancel__bEhfM:after {
    content: '';
    width: 55%;
    height: 2px;
    background: #fff;
    position: absolute;
    top: 48%;
    left: 22%;
    transform: rotate(-45deg);
    transition: all 0.3s ease-out;
}

.Sapper_btnCancel__bEhfM:after {
    transform: rotate(45deg);
    transition: all 0.3s ease-out;
}

.Sapper_btnCancel__bEhfM:hover:before,
.Sapper_btnCancel__bEhfM:hover:after {
    transform: rotate(180deg);
}
.Sapper_containerBtnBet__L8gCo{
    display: flex;
    justify-content: center;
    align-items: center;
}


/*.game_field{*/
/*    display: flex;*/
/*    justify-content: left;*/

/*    order: 1;*/
/*    width: 1000px;*/
/*    height: 1000px;*/
/*    !*border: 1px green solid;*!*/
/*}*/
/*.UI{*/
/*    display: flex;*/
/*    justify-content: right;*/
/*    order: 2;*/
/*    width: 500px;*/
/*    height: 500px;*/
/*    !*border: 1px red solid;*!*/
/*}*/
@media (max-width: 880px) {
    .Sapper_wrapperContentGame__12YMx{
        flex-direction: column-reverse;
    }

    







}
@media screen and (max-width: 799px){
    .Sapper_mainCotainerRoulete__gvOiz{
        margin-left: 0;
    }
}
@media screen and (max-width: 1000px){
    .Sapper_containerGame__xGbMC{
        padding-top: 10px;
    }
    .Sapper_blockHistoryButton__jpVHW{
        position: relative;
        display: flex;
        justify-content: flex-end;
    }
    .Sapper_button__QbDZN,.Sapper_containerMines__dvWVf{
        width: 90%;
    }
    h1{
        margin:0 0 0.5rem;
    }
    .Sapper_containerTable__b3OmQ{
        width: 100%;
        padding: 10px 0 10px 0;
        justify-content: center;
        align-items: center;
        order:1;
        border-bottom: 1px solid #ffffff30; /* Добавляем красную линию справа */
        border-right: 0;
    }
    .Sapper_containerGame__xGbMC{
        order: 2;
        margin-top: 50px;
        padding-bottom: 0;
    }
    .Sapper_wrapperContentGame__12YMx{
        margin:0;
        margin-top: 60px;

    }
    .Sapper_containerNamingsGame__7RXtW{
        margin-top:70px;
        padding: 0 10px;
    }
    .Sapper_mainCotainerRoulete__gvOiz{
        margin-left: 0;
    }
    .Sapper_containerBets__Q3-9D{
        gap:2px;
        margin-bottom: 50px;

    }
    .Sapper_containerBetInGame__puzDj{
        flex-basis: calc(100% - 0.5rem);
    }
    .Sapper_containerBetInGameSuccses__hULC1{
        flex-basis: calc(100% - 0.5rem);
    }
    .Sapper_bet_container__Dy3Uo{
        width: 90%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Sapper/Sapper.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;;IAEtB,gBAAgB;;IAEhB,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,iCAAiC;IACjC,6CAA+B,EAAE,uBAAuB;;AAE5D;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,QAAQ;IACR,UAAU;AACd;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,oDAAoD;IACpD,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,wBAAwB;IACxB,sDAAwC;AAC5C;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sCAAsC,EAAE,oBAAoB;IAC5D,aAAa;IACb,yDAAyD,EAAE,mCAAmC;IAC9F,aAAa,EAAE,iDAAiD;IAChE,mBAAmB,EAAE,iCAAiC;IACtD,yEAAyE,EAAE,uBAAuB;IAClG,qDAAqD,EAAE,0CAA0C;AACrG;AACA;IACI,eAAe;AACnB;AACA;IACI,0EAA0E,EAAE,gCAAgC;AAChH;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,kBAAkB,EAAE,4BAA4B;IAChD,8CAA8C,EAAE,8BAA8B;IAC9E,2DAA2D,EAAE,8BAA8B;AAC/F;;AAEA;IACI,2BAA2B,EAAE,kCAAkC;IAC/D,qBAAqB,EAAE,oCAAoC;IAC3D,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;AACA;IACI;QACI,UAAU;;IAEd;IACA;QACI,UAAU;;IAEd;AACJ;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;;IAEI,aAAa,MAAM,6BAA6B;;IAEhD,aAAa;IACb,mBAAmB,aAAa,kCAAkC;IAClE,iBAAiB,eAAe,kCAAkC;;AAEtE;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;;AAEZ;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;IACjB,8FAA8F;AAClG;AACA;IACI;;yBAEqB;IACrB,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,wFAAwF;IACxF,mBAAmB;IACnB,aAAa;IACb,sDAAwC;IACxC,6BAA6B;IAC7B,mBAAmB;;AAEvB;AACA;IACI,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,2DAA6C;;AAEjD;AACA;IACI;QACI,UAAU;QACV,mBAAmB,EAAE,sBAAsB;;IAE/C;IACA;QACI,UAAU;;QAEV,qBAAqB,EAAE,qBAAqB;;IAEhD;AACJ;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB,EAAE,mDAAmD;IAC5E,sBAAsB;IACtB,mBAAmB,EAAE,iDAAiD;IACtE,aAAa,EAAE,0EAA0E;IACzF,gBAAgB;IAChB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;AACA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;AACA;IACI;;QAEI,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;AACA;;IAEI,eAAe;IACf,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,sDAAsD;IACtD,6CAA+B,EAAE,uBAAuB;;AAE5D;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA;;IAEI,aAAa;IACb,YAAY;;IAEZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;;IAEnB,uFAAuF;AAC3F;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,KAAK;IACL,OAAO;IACP,cAAc;IACd,YAAY;IACZ,aAAa;;AAEjB;;;;AAIA;IACI,kBAAkB,EAAE,gCAAgC;IACpD,QAAQ,EAAE,4CAA4C;IACtD,SAAS,EAAE,8CAA8C;IACzD,gCAAgC,EAAE,0CAA0C;AAChF;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;;IAEI,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;;IAEvB,SAAS;IACT,iCAAiC,EAAE,mCAAmC;IACtE,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,yCAA2B,EAAE,uBAAuB;IACpD,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;;IAElB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,QAAQ;AACZ;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sDAAwC;IACxC,6BAA6B;;AAEjC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;;IAEhB,aAAa;;;IAGb,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY,EAAE,oCAAoC;IAClD,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;IACjB,oBAAoB,EAAE,6CAA6C;;AAEvE;AACA;;IAEI,UAAU;AACd;;;AAGA;;IAEI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;;IAEtB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,uCAAuC;IACvC,wCAAwC;;AAE5C;AACA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,uCAAuC;IACvC,wCAAwC;;AAE5C;AACA;IACI,qBAAqB;IACrB,sCAAsC;IACtC,oCAAoC;IACpC,wCAAwC;AAC5C;AACA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,uCAAuC;IACvC,wCAAwC;AAC5C;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI,aAAa;IACb,WAAW;IACX,aAAa;;IAEb,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,oDAAsC;IACtC,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,iBAAiB,EAAE,qEAAqE;;;AAG5F;AACA;IACI,WAAW;IACX,YAAY;IACZ,gDAAgD;IAChD,mBAAmB;IACnB,eAAe;IACf,eAAe;;IAEf,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAKT,yBAAyB;IAKzB,6BAA6B;AACjC;;AAEA;IAKI,wBAAwB;IAKxB,6BAA6B;AACjC;;AAEA;;IAMI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA,eAAe;AACf,qBAAqB;AACrB,6BAA6B;;AAE7B,gBAAgB;AAChB,qBAAqB;AACrB,sBAAsB;AACtB,mCAAmC;AACnC,IAAI;AACJ,OAAO;AACP,qBAAqB;AACrB,8BAA8B;AAC9B,gBAAgB;AAChB,oBAAoB;AACpB,qBAAqB;AACrB,iCAAiC;AACjC,IAAI;AACJ;IACI;QACI,8BAA8B;IAClC;;;;;;;;;;AAUJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,yBAAyB;IAC7B;IACA;QACI,UAAU;IACd;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,OAAO;QACP,kCAAkC,EAAE,mCAAmC;QACvE,eAAe;IACnB;IACA;QACI,QAAQ;QACR,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,QAAQ;QACR,gBAAgB;;IAEpB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,OAAO;QACP,mBAAmB;;IAEvB;IACA;QACI,+BAA+B;IACnC;IACA;QACI,+BAA+B;IACnC;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".mainCotainerRoulete{\n    display: flex;\n    flex-direction: column;\n\n    color:whitesmoke;\n    \n    min-height: 100vh;\n    font-family: Popins,sans-serif;\n    padding: 0 10px;\n}\n.step {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    font-size: 18px;\n    margin-bottom: 10px;\n    color: white;\n    line-height: 1.5;\n    text-align: center;\n  }\n  \n  .highlight {\n    color: greenyellow;\n    font-weight: bold;\n  }\n.button{\n    display: flex;\n    justify-content: center;\n}\n.nextKoef{\n    background-color: green!important;\n    animation: fadeInKoef 0.5s ease; /* Анимация появления */\n\n}\n.buttonsTools{\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    display: flex;\n    gap:10px;\n    z-index: 2;\n}\n.howToPlay{\n    background-color: #0f1721;\n}\n.infoMaxWin{\n    display: flex;\n    justify-content: center;\n    font-size: 17px;\n    gap:10px;\n    background: #00000061;\n    padding: 10px;\n    border-radius: 10px;\n    color: gold;\n}\n.infoMaxWin div{\n    text-align: center;\n}\n.shiny_button{\n    position: relative;\n    display: inline-block;\n    font-size: 20px;\n    color: #fff;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    background: linear-gradient(45deg, #ff8c00, #ffa500);\n    border: none;\n    border-radius: 10px;\n    overflow: hidden;\n    cursor: pointer;\n    box-shadow: 0 3px 12px rgba(255, 140, 0, 0.7);\n    transition: transform 0.3s ease;\n    text-align: center;\n}\n\n.shiny_button::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -150%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);\n    transform: skewX(-15deg);\n    animation: shiny-animation 2.5s infinite;\n}\n\n@keyframes shiny-animation {\n    0% {\n        left: -150%;\n    }\n    50% {\n        left: 100%;\n    }\n    100% {\n        left: 100%;\n    }\n}\n\n\n.containerMines{\n    display: flex;\n    justify-content: space-between;\n    background: #7223ca8a;\n    padding: 10px;\n    border-radius: 10px;\n}\n.infoMin{\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    font-size: 18px;\n    letter-spacing: 1px;\n    font-family: Popins,sans-serif;\n}\n.buttonChoiceMine{\n    text-align: center;\n    font-size: 23px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color:white;\n    width:39px;\n    height:39px;\n    border-radius: 10px;\n    background-color: #293069;\n    cursor: pointer;\n}\n.containerBets{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin:1rem 2rem 0 2rem;\n}\n.cellsContainer {\n    display: grid;\n    grid-template-columns: repeat(5, 60px); /* Сетка для ячеек */\n    grid-gap: 5px;\n    background: linear-gradient(135deg, #b8005980, #00a9c0ab); /* Градиентный фон для контейнера */\n    padding: 15px; /* Внутренние отступы для контейнера с ячейками */\n    border-radius: 15px; /* Закругление углов контейнера */\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3), 0 6px 6px rgba(0, 0, 0, 0.23); /* Тень для выделения */\n    transition: transform 0.3s ease, box-shadow 0.3s ease; /* Плавный переход для эффекта наведения */\n}\n.textQtyMine {\n    font-size: 14px;\n}\n.cellsContainer:hover {\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 10px 10px rgba(0, 0, 0, 0.2); /* Усиление тени при наведении */\n}\n.cell {\n    width: 60px;\n    height: 60px;\n    cursor: pointer;\n    background-color: #ffffff52;\n    border: 2px solid #f0f0f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    color: #333;\n    border-radius: 8px; /* Закругление углов ячеек */\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1); /* Внутренняя тень для ячеек */\n    transition: background-color 0.3s ease, transform 0.3s ease; /* Плавный переход для ячеек */\n}\n\n.cell:hover {\n    background-color: #0000004d; /* Изменение цвета при наведении */\n    transform: scale(1.1); /* Легкое увеличение при наведении */\n    border: 1px solid #ffffff42;\n}\n\nbody{\n    color: #0f1721;\n}\n@keyframes ApperAnimate {\n    0% {\n        opacity: 0;\n\n    }\n    100% {\n        opacity: 1;\n\n    }\n}\n.main{\n    margin-top: 4rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n.mainGame{\n\n    z-index: 1000;     /* establish flex container */\n\n    display: flex;\n    flex-direction: row;            /* default value; can be omitted */\n    flex-wrap: nowrap;              /* default value; can be omitted */\n\n}\n.containerInfGame{\n    display: flex;\n    flex-direction: column;\n    width: 30%;\n    align-items: center;\n    justify-content: center;\n    order: 0;\n\n}\n.textContainer {\n    font-size: 30px;\n    color: whitesmoke;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n    /*margin-top: 20px; !* Регулируйте, чтобы создать желаемый отступ между текстом и таймером *!*/\n}\n.containerNamingsGame{\n    /*margin:10px;\n    margin-left: 20px;\n    margin-bottom: 10px;*/\n    text-align: center;\n    font-family: Poppins, sans-serif;\n    margin: 20px;\n}\n\n.containerBetInGame{\n    display: flex;\n    flex-direction: row;\n    order: 2;\n    justify-content: space-between;\n    align-items: center;\n    flex-basis: calc(25% - 0.5rem);\n    height: 60px;\n    gap: 1.5rem;\n    background: linear-gradient(315deg, var(--bg-color-start) 50%, var(--bg-color-end) 100%);\n    border-radius: 1rem;\n    padding: 1rem;\n    animation: ApperAnimate 0.8s ease-in-out;\n    animation-fill-mode: forwards;\n    margin-bottom: 1rem;\n\n}\n.AllAmount{\n    font-size: 25px;\n    color: #1be513;\n    font-family: Poppins, sans-serif;\n    margin-right: 1rem;\n}\n\n.animateAmount{\n    animation: expandAnimation 1.5s ease forwards;\n\n}\n@keyframes expandAnimation {\n    0% {\n        opacity: 0;\n        transform: scale(1); /* Начальный масштаб */\n\n    }\n    100% {\n        opacity: 1;\n\n        transform: scale(1.5); /* Конечный масштаб */\n\n    }\n}\n.headerBetName{\n    font-size: 20px;\n    color: var(--font-color);\n    font-family: Poppins, sans-serif;\n    margin-left: 1rem;\n}\n\n.wrapperContentGame{\n    display: flex;\n    flex-direction: row;\n    background-color: #242c54;\n    border-radius: 10px;\n    flex-flow: row-reverse;\n    position:relative;\n}\n.containerGame {\n    position: relative;\n    width: 100%;\n    display: flex;\n    justify-content: center; /* Центрируем контейнер с ячейками по горизонтали */\n    flex-direction: column;\n    align-items: center; /* Центрируем контейнер с ячейками по вертикали */\n    padding: 20px; /* Добавляем отступы, чтобы контейнер был четко отделен от границ экрана */\n    padding-top:50px;\n    gap:20px;\n}\n.containerKoefs{\n    display: flex;\n    justify-content: center;\n    gap:10px;\n    flex-wrap: wrap;\n}\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: scale(0);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n@keyframes fadeInKoef {\n    from {\n        \n        transform: scale(0.5);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n.blockHistoryButton {\n    \n    cursor: pointer;\n    z-index: 2;\n}\n.koefBlock{\n    border-radius: 10px;\n    background-color: #6c8af999;\n    padding: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: Poppins, sans-serif;\n    flex-wrap: wrap;\n}\n\n.koefBlock.achive{\n    background: linear-gradient(45deg, #ff8c0091, #ffa500);\n    animation: fadeInKoef 0.5s ease; /* Анимация появления */\n\n}\n.upI{\n    position: absolute;\n    top:-5%;\n    left: 52%;\n    transform: translate(-50%, -50%);\n    color: #96e5b6;\n    font-size: 32px;\n    rotate: -45deg;\n}\n.blockInf{\n\n    display: flex;\n    height: 100%;\n\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap:0.5rem;\n}\n.blockInf h2{\n    color: whitesmoke;\n    font-family: \"Gilroy\", sans-serif;\n    font-weight: 500;\n    font-size: 1.4rem;\n    line-height: 1.6rem;\n    text-align: center;\n}\n.timerI{\n    font-size: 23px;\n    color:#96e5b5;\n}\n.containerTimer{\n    display: flex;\n    flex-direction: row;\n    gap:1rem;\n}\n.containerLast10{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap:4px;\n}\n\n.blockLast10{\n    width: 8px;\n    height: 1rem;\n    border-radius: 10px;\n\n    background: linear-gradient(180deg, var(--bg-color-start) 0%, var(--bg-color-end) 100%);\n}\n.blockLast10.x_3{\n    height: 1.5rem;\n}\n.blockLast10.x_5{\n    height: 2rem;\n}\n.containerInforamtionWheel{\n    position: relative;\n    top:0;\n    left: 0;\n    display: block;\n    width: 200px;\n    height: 300px;\n\n}\n\n\n\n.wrapperSvg,.containerInforamtionWheel{\n    position: absolute; /* Абсолютное позиционирование */\n    top: 50%; /* Положение по вертикали в середине блока */\n    left: 50%; /* Положение по горизонтали в середине блока */\n    transform: translate(-50%, -50%); /* Центрируем по вертикали и горизонтали */\n}\n\n.wrapper{\n    position: relative;\n    margin: 0 auto;\n}\n.containerTable{\n\n    display: flex;\n    order: 1;\n    flex-direction: column;\n    max-width: 500px;\n    justify-content: center;\n\n    gap: 1rem;\n    border-right: 1px solid #ffffff30; /* Добавляем красную линию справа */\n    padding: 3rem 3rem;\n}\n.result{\n    width: 60px;\n    height: 60px;\n    font-size: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: rgb(4, 197, 4);\n    animation: fadeIn 0.5s ease; /* Анимация появления */\n    border: 2px solid #ffffff42;\n    border-radius: 8px;\n}\n.no_bets{\n    display: flex;\n    margin-right: 30px;\n\n    justify-content: center;\n    align-items: center;\n    order: 3;\n    font-size: 30px;\n    color: white;\n    font-family: Gilroy, sans-serif;\n    font-weight: 700;\n}\n.containerBetsInf{\n    margin-top: 30px;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    display: flex;\n    order: 2;\n    flex-direction: column;\n    gap: 1em;\n}\n.containerBet{\n\n    display: flex;\n    flex-direction: row;\n    order: 2;\n    width: 100%;\n    justify-content: left;\n    align-items: center;\n    height: 50px;\n    gap: 1.5rem;\n    background-color: #242c54;\n    border-radius: 3rem;\n    padding: 1rem;\n    animation: ApperAnimate 0.5s ease-in-out;\n    animation-fill-mode: forwards;\n\n}\n.betsAmountInf{\n    color: greenyellow;\n    font-size: 20px;\n    font-family: Gilroy, sans-serif;\n    font-weight: 600;\n}\n.btnCancel{\n    background-color: red;\n}\n.choice_container{\n    margin-top: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n.imgContainer{\n    margin-top: 1rem;\n\n    display: flex;\n\n\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n.imgContainer img{\n    width: 100%;\n    height: auto; /* Сохраняем пропорции изображения */\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n    pointer-events: none; /* Отключение взаимодействия с изображением */\n\n}\n.img\n.selected {\n    opacity: 1;\n}\n\n\n.bet_container{\n\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n\n    /*width: 300px;*/\n}\n.select-color__color_x2 {\n    --font-color: #94B2FF;\n    --bg-color-start: rgba(90, 96, 228, .224);\n    --bg-color-end: rgba(88, 103, 236, .64);\n    --border-color: rgba(139, 157, 254, .18);\n\n}\n.select-color__color_x50 {\n    --font-color: #A4FDC7;\n    --bg-color-start: rgba(43, 172, 71, .224);\n    --bg-color-end: rgba(74, 202, 110, .64);\n    --border-color: rgba(139, 254, 185, .18);\n\n}\n.select-color__color_x3 {\n    --font-color: #ef294e;\n    --bg-color-start: rgb(208 74 74 / 12%);\n    --bg-color-end: rgb(255 11 11 / 34%);\n    --border-color: rgba(184, 151, 255, .18);\n}\n.select-color__color_x5 {\n    --font-color: #FFEDC8;\n    --bg-color-start: rgba(216, 164, 87, .224);\n    --bg-color-end: rgba(218, 197, 87, .64);\n    --border-color: rgba(254, 208, 139, .18);\n}\n.opac{\n    opacity: 0.1;\n}\n@keyframes pulse {\n    0% {\n        font-size: 20px;\n    }\n    50% {\n        font-size: 30px;\n    }\n    100% {\n        font-size: 20px;\n    }\n}\n.text_block{\n    z-index: 1000;\n    width: 100%;\n    display: flex;\n\n    margin-top: 30px;\n    justify-content: center;\n    font-family: \"Gilroy\" , sans-serif;\n    font-weight: 600;\n    color: #053fc7;\n    animation: pulse 2s infinite alternate;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n.blockButtonCancel{\n    font-size: 28px;\n    color: red;\n    cursor: pointer;\n    margin-left: auto; /* Это свойство поместит блок .blockButtonCancel в конец контейнера */\n\n\n}\n.btnCancel {\n    width: 50px;\n    height: 50px;\n    box-shadow: 0px 10 10px 10px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    background: red;\n    cursor: pointer;\n\n    position: absolute;\n    display: block;\n    z-index: 200;\n    text-indent: -9999px;\n}\n\n.btnCancel:before,\n.btnCancel:after {\n    content: '';\n    width: 55%;\n    height: 2px;\n    background: #fff;\n    position: absolute;\n    top: 48%;\n    left: 22%;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.btnCancel:after {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.btnCancel:hover:before,\n.btnCancel:hover:after {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n.containerBtnBet{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n/*.game_field{*/\n/*    display: flex;*/\n/*    justify-content: left;*/\n\n/*    order: 1;*/\n/*    width: 1000px;*/\n/*    height: 1000px;*/\n/*    !*border: 1px green solid;*!*/\n/*}*/\n/*.UI{*/\n/*    display: flex;*/\n/*    justify-content: right;*/\n/*    order: 2;*/\n/*    width: 500px;*/\n/*    height: 500px;*/\n/*    !*border: 1px red solid;*!*/\n/*}*/\n@media (max-width: 880px) {\n    .wrapperContentGame{\n        flex-direction: column-reverse;\n    }\n\n    \n\n\n\n\n\n\n\n}\n@media screen and (max-width: 799px){\n    .mainCotainerRoulete{\n        margin-left: 0;\n    }\n}\n@media screen and (max-width: 1000px){\n    .containerGame{\n        padding-top: 10px;\n    }\n    .blockHistoryButton{\n        position: relative;\n        display: flex;\n        justify-content: flex-end;\n    }\n    .button,.containerMines{\n        width: 90%;\n    }\n    h1{\n        margin:0 0 0.5rem;\n    }\n    .containerTable{\n        width: 100%;\n        padding: 10px 0 10px 0;\n        justify-content: center;\n        align-items: center;\n        order:1;\n        border-bottom: 1px solid #ffffff30; /* Добавляем красную линию справа */\n        border-right: 0;\n    }\n    .containerGame{\n        order: 2;\n        margin-top: 50px;\n        padding-bottom: 0;\n    }\n    .wrapperContentGame{\n        margin:0;\n        margin-top: 60px;\n\n    }\n    .containerNamingsGame{\n        margin-top:70px;\n        padding: 0 10px;\n    }\n    .mainCotainerRoulete{\n        margin-left: 0;\n    }\n    .containerBets{\n        gap:2px;\n        margin-bottom: 50px;\n\n    }\n    .containerBetInGame{\n        flex-basis: calc(100% - 0.5rem);\n    }\n    .containerBetInGameSuccses{\n        flex-basis: calc(100% - 0.5rem);\n    }\n    .bet_container{\n        width: 90%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainCotainerRoulete": `Sapper_mainCotainerRoulete__gvOiz`,
	"step": `Sapper_step__DBagP`,
	"highlight": `Sapper_highlight__GcwZ7`,
	"button": `Sapper_button__QbDZN`,
	"nextKoef": `Sapper_nextKoef__+Urxr`,
	"fadeInKoef": `Sapper_fadeInKoef__9I1Re`,
	"buttonsTools": `Sapper_buttonsTools__mSXrl`,
	"howToPlay": `Sapper_howToPlay__UJ2dF`,
	"infoMaxWin": `Sapper_infoMaxWin__4qP7W`,
	"shiny_button": `Sapper_shiny_button__pTRwB`,
	"shiny-animation": `Sapper_shiny-animation__En5B6`,
	"containerMines": `Sapper_containerMines__dvWVf`,
	"infoMin": `Sapper_infoMin__po2Pp`,
	"buttonChoiceMine": `Sapper_buttonChoiceMine__YUGxa`,
	"containerBets": `Sapper_containerBets__Q3-9D`,
	"cellsContainer": `Sapper_cellsContainer__FtYUg`,
	"textQtyMine": `Sapper_textQtyMine__uWWgc`,
	"cell": `Sapper_cell__gySjS`,
	"main": `Sapper_main__JWUG8`,
	"mainGame": `Sapper_mainGame__XMdfq`,
	"containerInfGame": `Sapper_containerInfGame__ks0vt`,
	"textContainer": `Sapper_textContainer__Qj4qu`,
	"containerNamingsGame": `Sapper_containerNamingsGame__7RXtW`,
	"containerBetInGame": `Sapper_containerBetInGame__puzDj`,
	"ApperAnimate": `Sapper_ApperAnimate__PhGIk`,
	"AllAmount": `Sapper_AllAmount__tCQ4-`,
	"animateAmount": `Sapper_animateAmount__ah6Qo`,
	"expandAnimation": `Sapper_expandAnimation__tCC2X`,
	"headerBetName": `Sapper_headerBetName__N+VJ8`,
	"wrapperContentGame": `Sapper_wrapperContentGame__12YMx`,
	"containerGame": `Sapper_containerGame__xGbMC`,
	"containerKoefs": `Sapper_containerKoefs__OeUFn`,
	"blockHistoryButton": `Sapper_blockHistoryButton__jpVHW`,
	"koefBlock": `Sapper_koefBlock__Lvish`,
	"achive": `Sapper_achive__8R9eE`,
	"upI": `Sapper_upI__d8q8K`,
	"blockInf": `Sapper_blockInf__vx9lh`,
	"timerI": `Sapper_timerI__csuct`,
	"containerTimer": `Sapper_containerTimer__vN5Uu`,
	"containerLast10": `Sapper_containerLast10__apVzA`,
	"blockLast10": `Sapper_blockLast10__aprpV`,
	"x_3": `Sapper_x_3__B0puR`,
	"x_5": `Sapper_x_5__oX2Zj`,
	"containerInforamtionWheel": `Sapper_containerInforamtionWheel__Z6jeY`,
	"wrapperSvg": `Sapper_wrapperSvg__qu2gs`,
	"wrapper": `Sapper_wrapper__8sCnG`,
	"containerTable": `Sapper_containerTable__b3OmQ`,
	"result": `Sapper_result__Araf6`,
	"fadeIn": `Sapper_fadeIn__P2Kym`,
	"no_bets": `Sapper_no_bets__9y8XF`,
	"containerBetsInf": `Sapper_containerBetsInf__STTQB`,
	"containerBet": `Sapper_containerBet__RjNO3`,
	"betsAmountInf": `Sapper_betsAmountInf__d6KJx`,
	"btnCancel": `Sapper_btnCancel__bEhfM`,
	"choice_container": `Sapper_choice_container__fXzOv`,
	"imgContainer": `Sapper_imgContainer__MTtai`,
	"img": `Sapper_img__yPkas`,
	"selected": `Sapper_selected__XtAoT`,
	"bet_container": `Sapper_bet_container__Dy3Uo`,
	"select-color__color_x2": `Sapper_select-color__color_x2__Ulolt`,
	"select-color__color_x50": `Sapper_select-color__color_x50__tGjA2`,
	"select-color__color_x3": `Sapper_select-color__color_x3__b9y9u`,
	"select-color__color_x5": `Sapper_select-color__color_x5__mZpYC`,
	"opac": `Sapper_opac__HkBYh`,
	"text_block": `Sapper_text_block__pVOB7`,
	"pulse": `Sapper_pulse__fiUzM`,
	"blockButtonCancel": `Sapper_blockButtonCancel__uEuRF`,
	"containerBtnBet": `Sapper_containerBtnBet__L8gCo`,
	"containerBetInGameSuccses": `Sapper_containerBetInGameSuccses__hULC1`
};
export default ___CSS_LOADER_EXPORT___;
